import _reducer, {
  dosTaskFilterResult as _dosTaskFilterResult,
  taskOwnersResult as _taskOwnersResult,
  taskCentres as _taskCentres,
  taskTypes as _taskTypes,
} from './reducer';
import * as _actions from './actions';
import * as _accessors from './accessors';
import {
  reducer as _taskStatisticResult,
  actions as _taskStatisticActions,
} from './TaskStatistic';

export const reducer = _reducer;
export const dosTaskFilterResult = _dosTaskFilterResult;
export const taskOwnersResult = _taskOwnersResult;
export const taskCentres = _taskCentres;
export const taskTypes = _taskTypes;
export const actions = _actions;
export const accessors = _accessors;
export const taskStatisticActions = _taskStatisticActions;
export const taskStatisticResult = _taskStatisticResult;



// WEBPACK FOOTER //
// ./data/Tasks/index.js